export type ItemForm = typeof itemForm;

const name = {
  key: 'name',
  label: 'クーポン名',
  helperText: 'お客様のカート画面に表示されます。',
} as const;

const couponCode = {
  key: 'code',
  label: 'クーポンコード',
  helperText: '半角英数字30文字以内',
} as const;

const discount = {
  key: 'discount',
  label: '割引額',
  helperText: '注文の合計金額から割引されます。',
} as const;

const conditionValue = {
  key: 'condition_value',
  label: '最低利用金額',
} as const;

const maxUsagePerUser = {
  key: 'max_usage_per_user',
  label: 'ユーザー毎の利用上限回数',
} as const;

const validFrom = {
  key: 'valid_from',
  label: '利用開始日',
} as const;

const validTo = {
  key: 'valid_to',
  label: '利用終了日',
} as const;

const status = {
  key: 'status',
  label: 'クーポンのステータス',
} as const;

const availableOrderMethod = {
  key: 'available_order_method',
  label: '利用可能な注文方法',
};
export const itemForm = {
  name,
  couponCode,
  discount,
  conditionValue,
  maxUsagePerUser,
  validFrom,
  validTo,
  availableOrderMethod,
  status,
};
